export default "__VITE_ASSET__Br6Nn6xL__"